module.exports = __webpack_public_path__ + "static/img/pic-logo1@2x.3dafe57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/pic-logo1@2x.png
// module id = 31
// module chunks = 0